<div class="scrollable-component">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<cv-generic-integration-base-table
					[label]="label"
					[model]="model.model"
					[formBuilderConfig]="formBuilderConfig"
					[params]="params"
					[extraData]="extraData"
					[callBacks]="model.callBacks">
				</cv-generic-integration-base-table>
			</div>
		</div>
	</div>
</div>
